<div class="container-fluid">
    <iframe frameborder="0" allowfullscreen width="100%" style="overflow: hidden; min-height: 90vh" [src]="url"></iframe>
</div>
